import React from "react";
import cn from "classnames";
import DriverCard from "../../../components/DriverCard";
import { useTranslation } from "react-i18next";

function AllDriversList({
  drivers,
  handleClick,
  selectedRef,
  selectedDriverId,
  children,
}) {
  const { t } = useTranslation("common");
  return (
    <>
      {drivers?.map((driver) => (
        <DriverCard
          selectedRef={selectedRef}
          key={driver.id}
          data={driver}
          onClick={handleClick}
          selectedDriverId={selectedDriverId}
        />
      ))}
      {children}
    </>
  );
}

export default React.memo(AllDriversList);
